// extracted by mini-css-extract-plugin
module.exports = {"wordsList":"SearchWords_wordsList__3E0zN","wordsButton":"SearchWords_wordsButton__1_IGn"};